import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import styles from "./LeftNavProjectTab.module.scss";

const LeftNavProjectTab = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const {
    active: activeProp,
    label,
    labelKey,
    onClick: onClickProp,
    url,
  } = props;

  const onClick = useCallback(() => {
    if (onClickProp) {
      onClickProp();
    }

    if (url) {
      history.push(url);
    }
  }, [history, url, onClickProp]);

  const active = useMemo(
    () => activeProp || location.pathname === url,
    [activeProp, location, url]
  );

  const display = useMemo(() => {
    if (label) {
      return label;
    }

    if (labelKey) {
      return t(labelKey);
    }

    return "";
  }, [label, labelKey, t]);

  if (active) {
    return (
      <div className={styles.active} onClick={onClick}>
        <span>{display}</span>
      </div>
    );
  }

  return (
    <div className={styles.inactive} onClick={onClick}>
      <span>{display}</span>
    </div>
  );
};

export default LeftNavProjectTab;
